<template>
  <div class="login-container">
    <el-form @submit.prevent="handleLogin" label-width="80px">
      <h2>水质检测管理系统</h2>
      <el-form-item label="手机号">
        <el-input v-model="phone" placeholder="请输入手机号"></el-input>
      </el-form-item>
      <el-form-item label="密码">
        <el-input v-model="password" type="password" placeholder="请输入密码"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleLogin" class="login-button">登录</el-button>
      </el-form-item>
    </el-form>
    <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
  </div>
</template>


<script>
import api from '../api';

export default {
  name: 'LoginView',
  data() {
    return {
      // 使用硬编码的超级管理员账号
      phone: '', // 超级管理员手机号
      password: '', // 超级管理员密码
      errorMessage: ''
    };
  },
  methods: {
    // 登录逻辑示例
    async handleLogin() {
      try {
        const response = await api.post('/web/login/pass', {
          phone: this.phone,
          password: this.password,
        });
        if (response.code === 200) {
          const token = response.data.token;
          const permission = response.data.permission;
          const mallManageAuth = response.data.mallManageAuth || 0;
          localStorage.setItem('token', token); // 保存 token
          localStorage.setItem('permission', permission); // 保存权限信息
          localStorage.setItem('mallManageAuth', mallManageAuth); // 保存商城管理权限
          this.$router.push('/home'); // 登录成功后跳转页面
        } else {
          this.errorMessage = response.data.msg || "登录失败，请检查手机号和密码";
        }
      } catch (error) {
        console.error("登录请求失败:", error);
        this.errorMessage = "登录请求失败，请稍后重试";
      }
    }
  }
};
</script>

<style scoped>
.login-background {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-image: url('@/assets/images/background.jpg');
  background-size: cover;
  background-position: center;
}
.login-container {
  max-width: 400px;
  margin: 0 auto;
  padding: 40px;
  background-color: #ffffff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  text-align: center;
}

h2 {
  font-size: 24px;
  margin-bottom: 20px;
  color: #333;
}

.login-button {
  width: 100%;
}

.error-message {
  margin-top: 15px;
  color: red;
  font-size: 14px;
}

</style>
